import React, { useState, useEffect } from 'react'
import { Panel, Button, Input, ControlLabel } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function SummaryProjectApprovalSenceStaffWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const onSubmit = (data) => {
    console.log('data', data)
  }

  return (
    <div>
      <Panel header={schema.header} collapsible defaultExpanded bordered shaded>
        <ControlLabel>
          {requiredFiled(schema.inputSummaryProject.validators, schema.inputSummaryProject.label)}
        </ControlLabel>
        <ErrorMessage error={errors[schema.inputSummaryProject.name]} />
        <br />
        <Input
          name={schema.inputSummaryProject.name}
          inputRef={register(isValidators(schema.inputSummaryProject.validators))}
          rows={3}
          placeholder={schema.inputSummaryProject.placeholder}
          componentClass="textarea"
        />
        <hr />
        <Button style={{ width: 190 }} appearance="ghost" onClick={handleSubmit(onSubmit)}>
          {schema.buttonText}
        </Button>
      </Panel>
    </div>
  )
}
